<template>
    

<div class="page-header">
    <h1 class="">{{title}}</h1>
    <small class="lead">{{description}}</small>
     <hr class="my-4">
</div>

</template>

<script>
export default {
    name: 'PageTitle',
    props: {
        title: String,
        description: String,
    }
}
</script>